import React from 'react';

export default function RowHeaders(props) {
  let rows = props.items.map((item, i) => {
    return (
      <div key={i} className="abl-row" data-duration={item.duration} style={{height: item.height}}>
        <div className="abl-cell">
        {item.name}
        </div>
      </div>
    );
  });

  return (
    <div className="abl-row-headers">
      {rows}
    </div>
  );
};


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule/row_headers.js
 **/